<template>
    <div>
        <rkm-area
            type="section"
            title="Título de eleitor"
        >
            <TituloEleitor :model="model" />
        </rkm-area>

        <rkm-area
            type="section"
            title="Carteira de identidade (RG)"
        >
            <CarteiraIdentidade
                :data-atual="dataAtual"
                :form="form.carteiraIdentidade"
                :model="model"
            />
        </rkm-area>

        <rkm-area
            type="section"
            title="Certidão"
        >
            <Certidao
                :data-atual="dataAtual"
                :form="form.certidao"
                :model="model"
            />
        </rkm-area>

        <rkm-area
            type="section"
            title="Carteira de trabalho (CTPS)"
        >
            <CarteiraTrabalho
                :data-atual="dataAtual"
                :form="form.carteiraTrabalho"
                :model="model"
            />
        </rkm-area>

        <rkm-area
            type="section"
            title="Carteira nacional de habilitação (CNH)"
        >
            <CarteiraNacionalHabilitacao
                :data-atual="dataAtual"
                :form="form.carteiraNacionalHabilitacao"
                :model="model"
            />
        </rkm-area>

        <rkm-area
            v-show="isEstrangeiro"
            type="section"
            title="Estrangeiro"
        >
            <EstrangeiroEntradaBrasil
                :data-atual="dataAtual"
                :model="model"
            />
        </rkm-area>

        <rkm-area
            type="section"
            title="Outros"
        >
            <Outro
                :form="form"
                :model="model"
            />
        </rkm-area>
    </div>
</template>

<script>
// Components.
import TituloEleitor from './documentos/TituloEleitor'
import CarteiraIdentidade from './documentos/CarteiraIdentidade'
import Certidao from './documentos/Certidao'
import CarteiraTrabalho from './documentos/CarteiraTrabalho'
import CarteiraNacionalHabilitacao from './documentos/CarteiraNacionalHabilitacao'
import EstrangeiroEntradaBrasil from './documentos/EstrangeiroEntradaBrasil'
import Outro from './documentos/Outro'

// Enuns.
import pais from '@/enums/cadastro/localizacao/pais'

export default {
    components: {
        TituloEleitor,
        CarteiraIdentidade,
        Certidao,
        CarteiraTrabalho,
        CarteiraNacionalHabilitacao,
        EstrangeiroEntradaBrasil,
        Outro,
    },
    props: {
        dataAtual: { type: String, required: true },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        enums: { pais },
    }),
    computed: {
        isEstrangeiro() {

            return this.model.paisNascimentoId !== this.enums.pais.BRASIL
        }
    },
}
</script>